import { useMutation } from "@tanstack/react-query";
import { config } from "@/config";
import { useAuthHeaders } from "@/hooks/use-auth-headers";
import { apiFetch } from "@/lib/api-client";
import {
  DesignNodeLabel,
  CreateDesignNodePayload,
} from "./use-create-design-node-service";

export type UpdateDesignNodePayload = CreateDesignNodePayload;

export async function updateDesignNode(
  payload: UpdateDesignNodePayload,
  uuid: string,
  id: string,
  token: string,
): Promise<{ data: any; label: DesignNodeLabel }> {
  const url = `${config.isometricApiUrl}/design-ontology-graph/${uuid}/update-node/${id}`;
  try {
    const response = await apiFetch(url, {
      method: "PUT",
      body: JSON.stringify(payload),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      const error: any = new Error(errorData.message || "Request failed");
      error.status = response.status;
      throw error;
    }
    const data = await response.json();
    return { ...data, label: payload.label };
  } catch (error) {
    console.error("Error:", error);
    throw error;
  }
}

export const useUpdateDesignNode = (
  onSettled?: (
    res: { data: any; label: DesignNodeLabel } | undefined,
    error: Error | null,
  ) => void,
) => {
  const { getAuthHeaders } = useAuthHeaders();

  return useMutation({
    mutationFn: (payload: {
      body: UpdateDesignNodePayload;
      id: string;
      uuid: string;
    }) => {
      const headers = getAuthHeaders();
      const token = headers.Authorization.replace("Bearer ", "");
      return updateDesignNode(payload.body, payload.uuid, payload.id, token);
    },
    onSettled,
  });
};
